module.exports = __webpack_public_path__ + "dist/media/ec_comp_file.c02dfa12.svg";